import React, {useState, useEffect} from 'react';
import { UnboxingModal, RevealModal, RevealRewardModal, ModalNotify } from '../components/Modals';
import './styles/inv-specials.css';
import { JsonRpc } from 'eosjs';
import { UXHelper, VideoLoader } from '../components/UXHelper';
import {RBoxInv, RBoxInvBug} from '../components/Items';
import { ExtinctionData, ApisProvider, ExtinctionVideoData, ItemsData} from '../components/feactures/dataProvider';
import { useNavigate } from "react-router-dom";
import { LayoutCol, LayoutContainer, LayoutRow } from './layouts/layout_bi_columns';

const urlIPFS = ApisProvider.ipfsProvider;
const collectionName = ExtinctionData.collectionName;

const rpcJs = new JsonRpc(ApisProvider.bdProvider);

export const InventorySpecials = ({ userData, debugData, showLoader, closerLoader }) => {
  
  const navigate = useNavigate();

  const PushUrl = (url) => {
    navigate(url);
  }

  if(!userData.isConnected){
    return (
        <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }

  return (
    <LayoutContainer>
      <div className="p-0 mb-3">
          <button onClick={() => PushUrl('/inventory')} className='backbtn'>Back</button>
      </div>
      <div className='container_lobbies lobby_boxes'>
        <div className='title_lobby'>
          <h2>Choose an Inventory</h2>
        </div>
        <div className='lobby_inventory'>
          <UXHelper title={'Crates'} url={"presaleboxes"} video={"https://extinctionwars.com/assets/videos/visuals/menu-items/menu_item_boxes.webm"}/>
          <UXHelper title={`Reward Boxes`} url={"rewardboxes"} video={"https://extinctionwars.com/assets/videos/visuals/menu-items/menu_item_boxes.webm"}/>
          {debugData.isBug && <UXHelper title={`Bugged Boxes`} url={"bugrewardboxes"} video={"https://extinctionwars.com/assets/videos/visuals/menu-items/menu_item_boxes.webm"}/>
}
        </div>
      </div>
    </LayoutContainer>
  )
}

export const InventoryPresaleBoxes = ({userData, showLoader, closerLoader}) => {

    const [pageAct, setPageAct] = useState(1);
    const [refreshComp, setRefreshComp] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [isDouble, setIsDouble] = useState(false);
    const [userAsset, setUserAsset] = useState();
    const [idChestUnboxed, setIdChestUnboxed] = useState(0);
    const [unboxModal, setUnboxModal] = useState(false);
    const [revealModal, setRevealModal] = useState(false);
    const [revealData, setRevealData] = useState({
      videoReval: '',
      itemReveal: '',
      videoReveal_2: '',
      itemReveal_2: '',
    });

    const [fType, setFType] = useState(false);
    const [matchType, setMatchType] = useState();


    const[debugAction, setDebugAction] = useState({
      bug: false,
      id_bug: '',
      double: '',
    })

    const [nofity, setNotify] = useState({
      status: false,
      error: false,
      title: '',
      msg: '',
      txId: '',
  })

    const schemaName = 'schema_name=crates';

    useEffect(() => {
      if(userData.isConnected){
        loadAssets();
      }

      return () => {

      };
    }, [pageAct, refreshComp, userData.isConnected]);

    useEffect(() => {
      if(userData.isConnected){
        loadAssets();
      }

      return () => {
        setPageAct(1)
      };
    }, [fType, matchType]);

    const loadAssets = async() => {
        setIsDouble(false);

        if(fType){
          const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&${schemaName}&owner=${userData.username}&page=${pageAct}&data.name=${matchType}&limit=20&order=desc&sort=asset_id`;

          const response = await fetch(api, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Origin': '*'
            }
          });
          const data = await response.json();
          const assetsData = data.data;
          setUserAsset(assetsData);
        }
        else{
          const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&${schemaName}&owner=${userData.username}&page=${pageAct}&limit=20&order=desc&sort=asset_id`;

          const response = await fetch(api, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Origin': '*'
            }
          });
          const data = await response.json();
          const assetsData = data.data;
          setUserAsset(assetsData);
        }
      }

    const loadRevealImg = async (templateId, templateId2, double) => {
      if(Number(double) === Number(ExtinctionData.ID_SALE_CRATE_DOUBLE)){
        const api1 = `${ApisProvider.atomicApi}atomicassets/v1/templates?ids=${templateId}&page=1&limit=100&order=desc&sort=created`;
        const response1 = await fetch(api1, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        
        const data1 = await response1.json();
        const assetData1 = data1.data;
        const itemType1 = assetData1[0].schema.schema_name;

        if(itemType1 === 'weapons'){
          const item_data = ItemsData.weapons.find(x => Number(x.templateId) === Number(templateId));
          setRevealData((state) => ({
            ...state,
            videoReveal: item_data.reveal_video,
            itemReveal: item_data.img,
          }))
        }
        else if(itemType1 === 'suits'){
            const item_data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateId));
            setRevealData((state) => ({
              ...state,
              videoReveal: item_data.reveal_video,
              itemReveal: item_data.img,
            }))
        } 
        
        const api2 = `${ApisProvider.atomicApi}atomicassets/v1/templates?ids=${templateId2}&page=1&limit=100&order=desc&sort=created`;
        const response2 = await fetch(api2, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });

        const data2 = await response2.json();
        const assetData2 = data2.data;
        const itemType2 = assetData2[0].schema.schema_name;

        if(itemType2 === 'weapons'){
          const item_data = ItemsData.weapons.find(x => Number(x.templateId) === Number(templateId2));
          setRevealData((state) => ({
            ...state,
            videoReveal_2: item_data.reveal_video,
            itemReveal_2: item_data.img,
          }))
        }
        else if(itemType2 === 'suits'){
            const item_data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateId2));
            setRevealData((state) => ({
              ...state,
              videoReveal_2: item_data.reveal_video,
              itemReveal_2: item_data.img,
            }))
        }



      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/templates?ids=${templateId}&page=1&limit=100&order=desc&sort=created`;

        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });

        const data = await response.json();
        const assetData = data.data;
        const itemType = assetData[0].schema.schema_name;
        
        if(itemType === 'weapons'){
          const item_data = ItemsData.weapons.find(x => Number(x.templateId) === Number(templateId));
          setRevealData((state) => ({
            ...state,
            videoReveal: item_data.reveal_video,
            itemReveal: item_data.img,
          }))
        }
        else if(itemType === 'suits'){
            const item_data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateId));
            setRevealData((state) => ({
              ...state,
              videoReveal: item_data.reveal_video,
              itemReveal: item_data.img,
            }))
        }
      }
        
    }
    
    const loadtable = async (chestId, double) => {
      setLoadingData(true);
      if(Number(double) === Number(ExtinctionData.ID_SALE_CRATE_DOUBLE)){
        const table = await rpcJs.get_table_rows({
          json: true,
          code: ExtinctionData.GEARS_CONTRACT,
          table: 'unboxassets',
          scope: chestId,
        });
        const {rows} = table;

        if(Number(rows.length) !== 0){
          const result1 = rows[0];
          const result2 = rows[1];
          loadRevealImg(result1.template_id, result2.template_id, double);
          setDebugAction({
            bug: false,
            id_bug: '',
            double: false,
          })
          setLoadingData(false);
        }
        else{
          setDebugAction({
            bug: true,
            id_bug: chestId,
            double: double,
          })
          setLoadingData(false);
        }
      }
      else {
        const table = await rpcJs.get_table_rows({
          json: true,
          code: ExtinctionData.GEARS_CONTRACT,
          table: 'unboxassets',
          scope: chestId,
        });
        const {rows} = table;
        console.log(rows)
        if(Number(rows.length) !== 0){
          const result = rows[0];
          loadRevealImg(result.template_id, 0, isDouble);
          setDebugAction({
            bug: false,
            id_bug: '',
            double: false,
          })
          setLoadingData(false);
        }
        else{
          setDebugAction({
            bug: true,
            id_bug: chestId,
            double: '',
          })
          setLoadingData(false);
        }
      }
    }
    
    const unpack = async (chestId, double) => {
      if(userData.whichProvider === 'Anchor'){
        if(Number(double) === Number(ExtinctionData.ID_SALE_CRATE_DOUBLE)){
          setIsDouble(true);
          try{
            const action = {
              account: 'atomicassets',
              name: 'transfer',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.GEARS_CONTRACT,
                asset_ids: [chestId],
                memo: 'unbox',
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);

            setIdChestUnboxed(chestId);
            setTimeout(loadtable, 5000, chestId, double);
            setUnboxModal(true);
            setLoadingData(true);
            })
          }catch(err){
            
          }
        }
        else{
          try{
            const action = {
              account: 'atomicassets',
              name: 'transfer',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.GEARS_CONTRACT,
                asset_ids: [chestId],
                memo: 'unbox',
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);

            setIdChestUnboxed(chestId);
            setTimeout(loadtable, 5000, chestId, double);
            setUnboxModal(true);
            setLoadingData(true);
            })
          }catch(err){
            
          }
        }
      }
      else if(userData.whichProvider === 'WaxCloud'){
        if(Number(double) === Number(ExtinctionData.ID_SALE_CRATE_DOUBLE)){
          setIsDouble(true);
          try{
            const action = {
                actions: [{
                    account: 'atomicassets',
                    name: 'transfer',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                      }],
                    data: {
                        from: userData.username,
                        to: ExtinctionData.GEARS_CONTRACT,
                        asset_ids: [chestId],
                        memo: 'unbox',
                    },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setNotify({
                status: true,
                error: false,
                title: 'Success',
                msg: 'Transaction Id:',
                txId: transaction.transaction_id,
              });
              setIdChestUnboxed(chestId);
              setTimeout(loadtable, 5000, chestId, double);
              setUnboxModal(true);
              setLoadingData(true);
          }
          catch(err){
                const msgError = err.message.split('assertion failure with message: ').join('')
                setNotify({
                  status: true,
                  error: true,
                  title: 'failed transaction',
                  msg: msgError,
              });
          }
        }
        else{
          try{
            const action = {
                actions: [{
                    account: 'atomicassets',
                    name: 'transfer',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                      }],
                    data: {
                        from: userData.username,
                        to: ExtinctionData.GEARS_CONTRACT,
                        asset_ids: [chestId],
                        memo: 'unbox',
                    },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setNotify({
                status: true,
                error: false,
                title: 'Success',
                msg: 'Transaction Id:',
                txId: transaction.transaction_id,
              });
              setIdChestUnboxed(chestId);
              setTimeout(loadtable, 5000, chestId, double);
              setUnboxModal(true);
              setLoadingData(true);
          }
          catch(err){
                const msgError = err.message.split('assertion failure with message: ').join('')
                setNotify({
                  status: true,
                  error: true,
                  title: 'failed transaction',
                  msg: msgError,
              });
          }
        }
      }
        
    }

    const revealNfts = async () => {
      if(isDouble === true){
        if(userData.whichProvider === 'Anchor'){
          try{
            const action = {
              account: ExtinctionData.GEARS_CONTRACT,
              name: 'claimcrate',
              authorization: [userData.auths],
              data: {
                pack_asset_id: idChestUnboxed,
                origin_roll_ids: [0, 1],
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            setUnboxModal(false);
            setRevealModal(true);
            })
  
          }catch(err){
           
          }
        }
        else if(userData.whichProvider === 'WaxCloud'){
          try{
            const action = {
                actions: [{
                    account: ExtinctionData.GEARS_CONTRACT,
                    name: 'claimcrate',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                    }],
                    data: {
                      pack_asset_id: idChestUnboxed,
                      origin_roll_ids: [0, 1],
                    },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setNotify({
                status: true,
                error: false,
                title: 'Success',
                msg: 'Transaction Id:',
                txId: transaction.transaction_id,
              });
              setUnboxModal(false);
              setRevealModal(true);
          }
          catch(err){
                const msgError = err.message.split('assertion failure with message: ').join('')
                setNotify({
                  status: true,
                  error: true,
                  title: 'failed transaction',
                  msg: msgError,
              });
          }
        }
      }else {
        if(userData.whichProvider === 'Anchor'){
          try{
            const action = {
              account: ExtinctionData.GEARS_CONTRACT,
              name: 'claimcrate',
              authorization: [userData.auths],
              data: {
                pack_asset_id: idChestUnboxed,
                origin_roll_ids: [0],
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            setUnboxModal(false);
            setRevealModal(true);
            })
  
          }catch(err){
            
          }
        }
        else if(userData.whichProvider === 'WaxCloud'){
          try{
            const action = {
                actions: [{
                    account: ExtinctionData.GEARS_CONTRACT,
                    name: 'claimcrate',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                    }],
                    data: {
                      pack_asset_id: idChestUnboxed,
                      origin_roll_ids: [0],
                    },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setNotify({
                status: true,
                error: false,
                title: 'Success',
                msg: 'Transaction Id:',
                txId: transaction.transaction_id,
              });
              setUnboxModal(false);
              setRevealModal(true);
          }
          catch(err){
                const msgError = err.message.split('assertion failure with message: ').join('')
                setNotify({
                  status: true,
                  error: true,
                  title: 'failed transaction',
                  msg: msgError,
              });
          }
        }
        
      }
    }

    const closeRevealModal = () => {
      setRefreshComp(!refreshComp);
      setRevealModal(false);
    }

    const filterTypeCapture = (evt) => {
      const filter = evt.target.value;
      if(filter !== 'Select Type'){
        setMatchType(filter);
        setFType(true);
      }else{
        setFType(false);
      }
    }
    const clearFilters = () => {
      setMatchType('');
      setFType(false);
    }

    const navigate = useNavigate();

    const PushUrl = (url) => {
      navigate(url);
    }

    if(!userData.isConnected){
      return (
          <div className='signIn_box'>
              <h2 className='signIn-letter'>You need to sign in before!</h2>
          </div>
      )
    }

    if(showLoader){
      return (
        <div className='loader_animation'>
          <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
        </div>
      )
    }

  return (
          <div className='inv_container'>
            {unboxModal &&
                <UnboxingModal chestId={idChestUnboxed} revealAction={() => revealNfts()} onLoading={loadingData} debugAction={debugAction} debugfunc={loadtable} />
            }
            {revealModal &&
                <RevealModal assetData={revealData} isDouble={isDouble} closeModal={() => closeRevealModal()}/>
            }
            <div className='top-controls-inv-selector'>
            <div className="row header-container">
              <div className="col p-0">
                <button onClick={() => PushUrl('/inventory/special-items')} className='backbtn'>Back</button>
              </div>
              <div className='col p-0'>
                <h1 className='title-inv'>Inventory Crates</h1>
              </div>
            </div>
            <div className='controls-section'>
                <div className='filters_sections'>
                  <select value={matchType} onChange={filterTypeCapture} className='filters-items normal-inv'>
                    <option defaultValue='Select Type'>Select Type</option>
                    <option value="Double Crate">Dual</option>
                    <option value="Suit Crate">Suits</option>
                    <option value="Weapon Crate">Weapons</option>
                  </select>
                  {(fType)
                    ? <button onClick={() => clearFilters()} className='clear-filters'>Clear</button>
                    : null
                  }
                </div>
                <div className="page-container">
                  {pageAct > 1 &&
                    <button onClick={() => setPageAct(pageAct - 1)} className='btn-page'>Prev Page</button>            
                  }
                  <span className='page-ident'>{pageAct}</span>
                  <button onClick={() => setPageAct(pageAct + 1)} className='btn-page'>Next Page</button>
                </div>
            </div>
          </div>
            <div className='section-items'>
            {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
                {userAsset &&
                <>
                    {userAsset.map((a)=> (
                      <div className='asset-box card-asset' key={a.asset_id}>
                        <div className='item_structurer_container'>
                          <div className='visual_item_container'>
                            <img src={urlIPFS + a.data.img} className='img_item' alt={a.name}/>
                            <span className='difuser_visual_item'></span>
                            <span className='title_id_item'>#{a.asset_id}</span>
                            <span className={`title_rarity_item ${a.name.split(" ").join("")}`}>{a.name}</span>
                          </div>
                          <div className='item_info_container_box'>
                            <div className='item-info-box2'>
                              <button className='btn-selector-box' onClick={() => {
                                      const idchest = a.asset_id;
                                      const templateIdDouble = a.template.template_id;
                                      unpack(idchest, templateIdDouble)}}>Unpack</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                    ))}
                </>
                }
            </div>
        </div>
  )
}

export const InventoryRewardsBoxes = ({userData, pricesFees, showLoader, closerLoader}) => {

  const [pageAct, setPageAct] = useState(1);
  const [refreshComp, setRefreshComp] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  
  const [isToken, setIsToken] = useState(false);
  const [noReward, setNoReward] = useState(false);

  const [idChestUnboxed, setIdChestUnboxed] = useState({
    id: '',
    templateId: '',
  });
  const [unboxModal, setUnboxModal] = useState(false);
  const [revealModal, setRevealModal] = useState(false);
  const [revealData, setRevealData] = useState();
  const [userAsset, setUserAsset] = useState();

  const [filters, setFilters] = useState({
    isLocation: false,
    boxLocation: '',
    isRarity: false,
    boxRarity: '',
  })

  const[debugAction, setDebugAction] = useState({
    bug: false,
    id_bug: '',
  })

  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
})

  const schemaName = 'schema_name=rewardboxes';

  useEffect(() => {
      if(userData.isConnected){
        loadAssets();
      }

  }, [pageAct, userData.isConnected, refreshComp]);

  useEffect(() => {
    if(userData.isConnected){
      loadAssets();
    }

    return () => {
      setPageAct(1)
    };

  }, [filters]);

    const loadAssets = async() => {
      if(filters.isLocation && filters.isRarity){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&${schemaName}&owner=${userData.username}&data.Rarity=${filters.boxRarity}&data.name=${filters.boxLocation}&page=${pageAct}&limit=20&order=desc&sort=asset_id`;
      
        const response = await fetch(api, {
          method: 'GET',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setRefreshComp(false);
      }
      else if(filters.isLocation){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&${schemaName}&owner=${userData.username}&data.name=${filters.boxLocation}&page=${pageAct}&limit=20&order=desc&sort=asset_id`;
      
        const response = await fetch(api, {
          method: 'GET',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setRefreshComp(false);
      }
      else if(filters.isRarity){
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&${schemaName}&owner=${userData.username}&data.Rarity=${filters.boxRarity}&page=${pageAct}&limit=20&order=desc&sort=asset_id`;
      
        const response = await fetch(api, {
          method: 'GET',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        const data = await response.json();
        const assetsData = data.data;
        setUserAsset(assetsData);
        setRefreshComp(false);
      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${collectionName}&${schemaName}&owner=${userData.username}&page=${pageAct}&limit=20&order=desc&sort=asset_id`;
      
      const response = await fetch(api, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const assetsData = data.data;
      setUserAsset(assetsData);
      setRefreshComp(false);
      }
        
    }

    const loadRevealImg = async (templateId) => {
      if(Number(templateId) === ExtinctionData.ID_REWARD_ONYX_1){
        const reward = '3 ONYX'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_ONYX_2){
        const reward = '10 ONYX'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_ONYX_3){
        const reward = '20 ONYX'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_ONYX_4){
        const reward = '30 ONYX'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_NEO_COMMON){
        const reward = '10 NEO'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_NEO_RARE){
        const reward = '13 NEO'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_NEO_EPIC){
        const reward = '20 NEO'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_NEO_LEGEND){
        const reward = '25 NEO'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_CHAL_COMMON){
        const reward = '10 CHAL'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_CHAL_RARE){
        const reward = '13 CHAL'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_CHAL_EPIC){
        const reward = '20 CHAL'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_CHAL_EPIC){
        const reward = '25 CHAL'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_ONYX_13){
        const reward = '60 ONYX'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_NOTHING){
        setIsToken(false);
        setNoReward(true);
      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/templates?ids=${templateId}&page=1&limit=100&order=desc&sort=created`;

        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });

        const data = await response.json();
        const assetData = data.data;
        const itemData = assetData[0].immutable_data;
        setRevealData(itemData);
      }
    }
    
    const loadtable = async (chestId) => {
      const table = await rpcJs.get_table_rows({
        json: true,
        code: ExtinctionData.GEARS_CONTRACT,
        table: 'unboxassets',
        scope: chestId,
      });
      const {rows} = table
      const result = rows[0];

      if(result !== undefined){
        loadRevealImg(result.template_id);
        setLoadingData(false);
        setDebugAction({
          bug: false,
          id_bug: '',
        });
      }
      else{
        setDebugAction({
          bug: true,
          id_bug: chestId,
        });
        setLoadingData(false);
      }
    }
    
    const unpack = async (chestId, templateid) => {
      if(userData.whichProvider === 'Anchor'){
        try{
          const action = {
            account: 'atomicassets',
            name: 'transfer',
            authorization: [userData.auths],
            data: {
              from: userData.username,
              to: ExtinctionData.GEARS_CONTRACT,
              asset_ids: [chestId],
              memo: 'unbox',
            },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
  
          setIdChestUnboxed({
            id: chestId,
            templateId: templateid,
          });
          setUnboxModal(true);
          setLoadingData(true);
          setTimeout(loadtable, 5000, chestId);
          })
        }catch(err){
          
        }
      }
      else if(userData.whichProvider === 'WaxCloud'){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                      from: userData.username,
                      to: ExtinctionData.GEARS_CONTRACT,
                      asset_ids: [chestId],
                      memo: 'unbox',
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            setIdChestUnboxed({
              id: chestId,
              templateId: templateid,
            });
            setUnboxModal(true);
            setLoadingData(true);
            setTimeout(loadtable, 5000, chestId);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }       
    }

    const revealNfts = async () => {
      if(userData.whichProvider === 'Anchor'){
        if(Number(idChestUnboxed.templateId) === Number(ExtinctionData.ID_REWARD_DUMMY_BOX)){
          try{
            const action = {
              account: ExtinctionData.GEARS_CONTRACT,
              name: 'claimdummy',
              authorization: [userData.auths],
              data: {
                pack_asset_id: idChestUnboxed.id,
                origin_roll_ids: [0],
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            setUnboxModal(false);
            setIdChestUnboxed({
              id: '',
              templateId: '',
            });
            setRevealModal(true);
            })
    
          }catch(err){
            
          }
        }else{
          try{
            const action = {
              account: ExtinctionData.GEARS_CONTRACT,
              name: 'claimreward',
              authorization: [userData.auths],
              data: {
                pack_asset_id: idChestUnboxed.id,
                origin_roll_ids: [0],
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            setUnboxModal(false);
            setIdChestUnboxed({
              id: '',
              templateId: '',
            });
            setRevealModal(true);
            })
    
          }catch(err){
            
          }
        }
      }
      else if(userData.whichProvider === 'WaxCloud'){
        if(Number(idChestUnboxed.templateId) === Number(ExtinctionData.ID_REWARD_DUMMY_BOX)){
          try{
            const action = {
                actions: [{
                  account: ExtinctionData.GEARS_CONTRACT,
                    name: 'claimdummy',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                      }],
                    data: {
                        pack_asset_id: idChestUnboxed.id,
                        origin_roll_ids: [0],
                      },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setIdChestUnboxed({
                id: '',
              templateId: '',
              });
              setUnboxModal(false);
              setRevealModal(true);
          }
          catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
            });
          }
        }
        else{
          try{
            const action = {
                actions: [{
                  account: ExtinctionData.GEARS_CONTRACT,
                    name: 'claimreward',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                      }],
                    data: {
                        pack_asset_id: idChestUnboxed.id,
                        origin_roll_ids: [0],
                      },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setIdChestUnboxed({
                id: '',
              templateId: '',
              });
              setUnboxModal(false);
              setRevealModal(true);
          }
          catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
          }
        }
      }
    }

  const closeRevealModal = () => {
    setRefreshComp(refreshComp + 1);
    setRevealModal(false);
  }
  const filterRarityCapture = (evt) => {
    const filter = evt.target.value;
    if(filter !== 'Select Rarity'){
      setFilters((state) => ({
        ...state,
        boxRarity: filter,
        isRarity: true,
      }));
    }else{
      setFilters((state) => ({
        ...state,
        boxRarity: '',
        isRarity: false,
      }));
    }
    
  }

  const filterNationCapture = (evt) => {
    const filter = evt.target.value;
    if(filter !== 'Select Nation'){
      setFilters((state) => ({
        ...state,
        boxLocation: filter,
        isLocation: true,
      }));
    }else{
      setFilters((state) => ({
        ...state,
        boxLocation: '',
        isLocation: false,
      }));
    }
  }

  const clearFilters = () => {
    setFilters({
      isLocation: false,
      boxLocation: '',
      isRarity: false,
      boxRarity: '',
    });
  }


  const navigate = useNavigate();

  const PushUrl = (url) => {
    navigate(url);
  }

  if(!userData.isConnected){
    return (
        <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }

return (
  <>    
      <div className='inv_container'>
          {unboxModal &&
              <UnboxingModal chestId={idChestUnboxed} revealAction={() => revealNfts()} onLoading={loadingData} debugAction={debugAction} debugfunc={loadtable}/>
          }
          {revealModal &&
              <RevealRewardModal assetData={revealData} isToken={isToken} noReward={noReward} closeModal={() => closeRevealModal()}/>
          }
          <div className='top-controls-inv-selector'>
            <div className="row header-container">
              <div className="col p-0">
                <button onClick={() => PushUrl('/inventory/special-items')} className='backbtn'>Back</button>
              </div>
              <div className='col p-0'>
                <h1 className='title-inv'>Inventory Reward Boxes</h1>
              </div>
            </div>
            <div className='controls-section'>
                <div className='filters_sections'>
                  <select value={filters.boxRarity} className='filters-items-dual' onChange={filterRarityCapture}>
                    <option defaultValue='Select Rarity'>Select Rarity</option>
                    <option value="Common">Common</option>
                    <option value="Rare">Rare</option>
                    <option value="Epic">Epic</option>
                    <option value="Legendary">Legendary</option>
                  </select>
                  <select value={filters.boxLocation} className='filters-items' onChange={filterNationCapture}>
                    <option defaultValue='Select Nation'>Select Location</option>
                    <option value="Silkhs">Silkhs</option>
                    <option value="Arakneths">Arakneths</option>
                    <option value="Council City">Council City</option>
                  </select>
                  {(filters.isLocation || filters.isRarity)
                    ? <button onClick={() => clearFilters()} className='clear-filters'>Clear Filters</button>
                    : <></>
                  }
                </div>
                <div className="page-container">
                  {pageAct > 1 &&
                    <button onClick={() => setPageAct(pageAct - 1)} className='btn-page'>Prev Page</button>            
                  }
                  <span className='page-ident'>{pageAct}</span>
                  <button onClick={() => setPageAct(pageAct + 1)} className='btn-page'>Next Page</button>
                </div>
            </div>
          </div>
          <div className='section-items'>
          {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
              setNotify({
                  status: false,
                  error: false,
                  title: '',
                  msg: '',
                  txId: '',
              })
            }}/>}
            {userAsset && 
                <>
                    {userAsset.map((a)=> (
                        <div className='asset-box card-asset' key={a.asset_id}>
                          <RBoxInv box={a} onUnbox={unpack}/>
                        </div>
                    ))}
                </>
            }
          </div>
      </div>
      </>
  )
}

export const BuggedRewardBoxes = ({userData, debugData, pricesFees, refresh, showLoader, closerLoader}) => {

  const [pageAct, setPageAct] = useState(1);
  const [refreshComp, setRefreshComp] = useState();
  const [loadingData, setLoadingData] = useState(false);

  useEffect(() => {
    if(userData.isConnected){
      setUserAsset(debugData.data);

        return () => {
          refresh();
        }
    }
  }, [refreshComp]);

  const[debugAction, setDebugAction] = useState({
    bug: false,
    id_bug: '',
  })
  
  const [isToken, setIsToken] = useState(false);
  const [noReward, setNoReward] = useState(false);

  const [userAsset, setUserAsset] = useState(debugData.data);
  const [idChestUnboxed, setIdChestUnboxed] = useState({
    id: '',
    templateId: '',
  });
  const [unboxModal, setUnboxModal] = useState(false);
  const [revealModal, setRevealModal] = useState(false);
  const [revealData, setRevealData] = useState();
  const [unboxCrateModal, setUnboxCrateModal] = useState(false);
  const [revealCrateModal, setRevealCrateModal] = useState(false);
  const [isDouble, setIsDouble] = useState(false);

  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
  })

  useEffect(() => {
      if(userData.isConnected){
        setUserAsset(debugData.data);

        return () => {
          refresh();
        }
      }
  }, [userData.isConnected]);

  useEffect(() => {
    if(userData.isConnected){
      setUserAsset(debugData.data);

        return () => {
          refresh();
        }
    }
}, [pageAct]);

    const loadRevealImg = async (templateId) => {
      if(Number(templateId) === ExtinctionData.ID_REWARD_ONYX_1){
        const reward = '3 ONYX'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_ONYX_2){
        const reward = '10 ONYX'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_ONYX_3){
        const reward = '20 ONYX'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_ONYX_4){
        const reward = '30 ONYX'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_NEO_COMMON){
        const reward = '10 NEO'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_NEO_RARE){
        const reward = '13 NEO'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_NEO_EPIC){
        const reward = '20 NEO'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_NEO_LEGEND){
        const reward = '25 NEO'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_CHAL_COMMON){
        const reward = '10 CHAL'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_CHAL_RARE){
        const reward = '13 CHAL'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_CHAL_EPIC){
        const reward = '20 CHAL'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_CHAL_EPIC){
        const reward = '25 CHAL'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_ONYX_13){
        const reward = '60 ONYX'
        setRevealData(reward);
        setIsToken(true);
      }
      else if(Number(templateId) === ExtinctionData.ID_REWARD_NOTHING){
        setIsToken(false);
        setNoReward(true);
      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/templates?ids=${templateId}&page=1&limit=100&order=desc&sort=created`;

        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });

        const data = await response.json();
        const assetData = data.data;
        const itemData = assetData[0].immutable_data;
        setRevealData(itemData);
      }
    }
    
    const loadtable = async (chestId) => {
      setLoadingData(true);
      setDebugAction({
        bug: false,
        id_bug: '',
      });

      const table = await rpcJs.get_table_rows({
        json: true,
        code: ExtinctionData.GEARS_CONTRACT,
        table: 'unboxassets',
        scope: chestId,
      });
      const {rows} = table
      const result = rows[0];
      if(result !== undefined){
        loadRevealImg(result.template_id);
        setLoadingData(false);
        setDebugAction({
          bug: false,
          id_bug: '',
        });
      }
      else{
        setDebugAction({
          bug: true,
          id_bug: chestId,
        });
        setLoadingData(false);
      }
    }

    const loadRevealCrateImg = async (templateId, templateId2, double) => {
      if(Number(double) === Number(ExtinctionData.ID_SALE_CRATE_DOUBLE)){
        const api1 = `${ApisProvider.atomicApi}atomicassets/v1/templates?ids=${templateId}&page=1&limit=100&order=desc&sort=created`;
        const response1 = await fetch(api1, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });
        
        const data1 = await response1.json();
        const assetData1 = data1.data;
        const itemType1 = assetData1[0].schema.schema_name;

        if(itemType1 === 'weapons'){
          const item_data = ItemsData.weapons.find(x => Number(x.templateId) === Number(templateId));
          setRevealData((state) => ({
            ...state,
            videoReveal: item_data.reveal_video,
            itemReveal: item_data.img,
          }))
        }
        else if(itemType1 === 'suits'){
            const item_data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateId));
            setRevealData((state) => ({
              ...state,
              videoReveal: item_data.reveal_video,
              itemReveal: item_data.img,
            }))
        } 
        
        const api2 = `${ApisProvider.atomicApi}atomicassets/v1/templates?ids=${templateId2}&page=1&limit=100&order=desc&sort=created`;
        const response2 = await fetch(api2, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });

        const data2 = await response2.json();
        const assetData2 = data2.data;
        const itemType2 = assetData2[0].schema.schema_name;

        if(itemType2 === 'weapons'){
          const item_data = ItemsData.weapons.find(x => Number(x.templateId) === Number(templateId2));
          setRevealData((state) => ({
            ...state,
            videoReveal_2: item_data.reveal_video,
            itemReveal_2: item_data.img,
          }))
        }
        else if(itemType2 === 'suits'){
            const item_data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateId2));
            setRevealData((state) => ({
              ...state,
              videoReveal_2: item_data.reveal_video,
              itemReveal_2: item_data.img,
            }))
        }



      }
      else{
        const api = `${ApisProvider.atomicApi}atomicassets/v1/templates?ids=${templateId}&page=1&limit=100&order=desc&sort=created`;

        const response = await fetch(api, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
          }
        });

        const data = await response.json();
        const assetData = data.data;
        const itemType = assetData[0].schema.schema_name;
        
        if(itemType === 'weapons'){
          const item_data = ItemsData.weapons.find(x => Number(x.templateId) === Number(templateId));
          setRevealData((state) => ({
            ...state,
            videoReveal: item_data.reveal_video,
            itemReveal: item_data.img,
          }))
        }
        else if(itemType === 'suits'){
            const item_data = ItemsData.suits.find(x => Number(x.templateId) === Number(templateId));
            setRevealData((state) => ({
              ...state,
              videoReveal: item_data.reveal_video,
              itemReveal: item_data.img,
            }))
        }
      }
        
    }

    const loadCratetable = async (chestId, double) => {
      setLoadingData(true);
      setDebugAction({
        bug: false,
        id_bug: '',
      });
      if(Number(double) === Number(ExtinctionData.ID_SALE_CRATE_DOUBLE)){
        const table = await rpcJs.get_table_rows({
          json: true,
          code: ExtinctionData.GEARS_CONTRACT,
          table: 'unboxassets',
          scope: chestId,
        });
        const {rows} = table;
        if(Number(rows.length) !== 0){
          const result1 = rows[0];
          const result2 = rows[1];
          loadRevealCrateImg(result1.template_id, result2.template_id, double);
          setDebugAction({
            bug: false,
            id_bug: '',
            double: false,
          })
          setLoadingData(false);
        }
        else{
          setDebugAction({
            bug: true,
            id_bug: chestId,
            double: double,
          })
          setLoadingData(false);
        }
      }
      else {
        const table = await rpcJs.get_table_rows({
          json: true,
          code: ExtinctionData.GEARS_CONTRACT,
          table: 'unboxassets',
          scope: chestId,
        });
        const {rows} = table;
        console.log(rows)
        if(Number(rows.length) !== 0){
          const result = rows[0];
          loadRevealCrateImg(result.template_id, 0, isDouble);
          setDebugAction({
            bug: false,
            id_bug: '',
            double: false,
          })
          setLoadingData(false);
        }
        else{
          setDebugAction({
            bug: true,
            id_bug: chestId,
            double: '',
          })
          setLoadingData(false);
        }
      }
    }

    const unpack = (chestId, templateid) => {
      if(Number(templateid) === Number(ExtinctionData.ID_SALE_CRATE_DOUBLE)){
        setIsDouble(true);
        setIdChestUnboxed(chestId);
        setUnboxCrateModal(true);
        setTimeout(loadCratetable, 5000, chestId, templateid);

      }
      else if(Number(templateid) === Number(ExtinctionData.ID_SALE_CRATE_WEAPON) || Number(templateid) === Number(ExtinctionData.ID_SALE_CRATE_SUIT)){
        setIsDouble(false);
        setIdChestUnboxed(chestId);
        setUnboxCrateModal(true);
        setTimeout(loadCratetable, 5000, chestId, templateid);
      }
      else{
        setIdChestUnboxed({
          id: chestId,
          templateId: templateid,
        });
        setUnboxModal(true);
        setIsDouble(false);
        setLoadingData(true);
        setTimeout(loadtable, 5000, chestId);
      }      
    }

    const revealNfts = async () => {
      if(userData.whichProvider === 'Anchor'){
        if(Number(idChestUnboxed.templateId) === Number(ExtinctionData.ID_REWARD_DUMMY_BOX)){
          try{
            const action = {
              account: ExtinctionData.GEARS_CONTRACT,
              name: 'claimdummy',
              authorization: [userData.auths],
              data: {
                pack_asset_id: idChestUnboxed.id,
                origin_roll_ids: [0],
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            setUnboxModal(false);
            setRevealModal(true);
            })
    
          }catch(err){
            
          }
        }else{
          try{
            const action = {
              account: ExtinctionData.GEARS_CONTRACT,
              name: 'claimreward',
              authorization: [userData.auths],
              data: {
                pack_asset_id: idChestUnboxed.id,
                origin_roll_ids: [0],
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            setUnboxModal(false);
            setRevealModal(true);
            })
    
          }catch(err){
           
          }
        }
      }
      else if(userData.whichProvider === 'WaxCloud'){
        if(Number(idChestUnboxed.templateId) === Number(ExtinctionData.ID_REWARD_DUMMY_BOX)){
          try{
            const action = {
                actions: [{
                  account: ExtinctionData.GEARS_CONTRACT,
                    name: 'claimdummy',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                      }],
                    data: {
                        pack_asset_id: idChestUnboxed.id,
                        origin_roll_ids: [0],
                      },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setUnboxModal(false);
              setRevealModal(true);
          }
          catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
          }
        }
        else{
          try{
            const action = {
                actions: [{
                  account: ExtinctionData.GEARS_CONTRACT,
                    name: 'claimreward',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                      }],
                    data: {
                        pack_asset_id: idChestUnboxed.id,
                        origin_roll_ids: [0],
                      },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setUnboxModal(false);
              setRevealModal(true);
          }
          catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
          }
        }
      }
    }

    const revealCrates = async () => {
      if(userData.whichProvider === 'Anchor'){
        if(isDouble === true){
          try{
            const action = {
              account: ExtinctionData.GEARS_CONTRACT,
              name: 'claimcrate',
              authorization: [userData.auths],
              data: {
                pack_asset_id: idChestUnboxed,
                origin_roll_ids: [0, 1],
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            setUnboxCrateModal(false);
            setRevealCrateModal(true);
            })
  
          }catch(err){
            
          }
        }
        else {
          try{
            const action = {
              account: ExtinctionData.GEARS_CONTRACT,
              name: 'claimcrate',
              authorization: [userData.auths],
              data: {
                pack_asset_id: idChestUnboxed,
                origin_roll_ids: [0],
              },
            }
            userData.sessionData.transact({action}).then(({transaction}) => {
            //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            setUnboxCrateModal(false);
            setRevealCrateModal(true);            
            })
  
          }catch(err){
           
          }
        }
      }
      else if(userData.whichProvider === 'WaxCloud'){
        if(isDouble === true){
          try{
            const action = {
                actions: [{
                    account: ExtinctionData.GEARS_CONTRACT,
                    name: 'claimcrate',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                    }],
                    data: {
                      pack_asset_id: idChestUnboxed,
                      origin_roll_ids: [0, 1],
                    },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setUnboxCrateModal(false);
              setRevealCrateModal(true);
          }
          catch(err){
                const msgError = err.message.split('assertion failure with message: ').join('')
                setNotify({
                  status: true,
                  error: true,
                  title: 'failed transaction',
                  msg: msgError,
              });
          }
        }else {
          try{
            const action = {
                actions: [{
                    account: ExtinctionData.GEARS_CONTRACT,
                    name: 'claimcrate',
                    authorization: [{
                        actor: userData.username,
                        permission: 'active',
                    }],
                    data: {
                      pack_asset_id: idChestUnboxed,
                      origin_roll_ids: [0],
                    },
                }],
            }
            const transaction = await userData.sessionData.api.transact(action, {
                blocksBehind: 3,
                expireSeconds: 1200,
              });
              setUnboxCrateModal(false);
              setRevealCrateModal(true);
          }
          catch(err){
                const msgError = err.message.split('assertion failure with message: ').join('')
                setNotify({
                  status: true,
                  error: true,
                  title: 'failed transaction',
                  msg: msgError,
              });
          }
        }
      }
    }  

  const closeRevealModal = () => {
    refresh();
    setRevealModal(false);
    setRevealCrateModal(false);
  }

  const navigate = useNavigate();

  const PushUrl = (url) => {
    navigate(url);
  }

  if(!userData.isConnected){
    return (
        <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }

  
return (
      <div>
        
          {unboxCrateModal && 
            <UnboxingModal chestId={idChestUnboxed} revealAction={() => revealCrates()} onLoading={loadingData} debugAction={debugAction} debugfunc={loadCratetable} />
          }
          {revealCrateModal &&
            <RevealModal assetData={revealData} isDouble={isDouble} closeModal={() => closeRevealModal()}/>
          }
          {unboxModal &&
              <UnboxingModal chestId={idChestUnboxed} revealAction={() => revealNfts()} onLoading={loadingData} debugAction={debugAction} debugfunc={loadtable}/>
          }
          {revealModal &&
              <RevealRewardModal assetData={revealData} isToken={isToken} noReward={noReward} closeModal={() => closeRevealModal()}/>
          }
          <div className='row top-controls-inv-selector'>
            <div className="row header-container">
              <div className="col p-0">
                <button onClick={() => PushUrl('/inventory/special-items')} className='backbtn'>Back</button>
              </div>
              <div className='col p-0'>
                <h1 className='title-inv'>Inventory Bugs Boxes</h1>
              </div>
            </div>
          </div>
          <div className='section-items'>
          {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
            {userAsset && 
                <>
                    {userAsset.map((a)=> (
                        <div className='asset-box box-specials' key={a.boxId}>
                          <RBoxInvBug id={a.boxId} debugAction={debugAction} onUnbox={unpack} />
                        </div>
                    ))}
                </>
            }
          </div>
      </div>
      
  )
}